<!--
=========================================================
* Vue Argon Dashboard 2 - v4.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { computed } from "vue";
import { useStore } from "vuex";
import Sidenav from "./views/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";

import LoadingBar from '@/views/components/common/LoadingBar.vue';

const store = useStore();
const isNavFixed = computed(() => store.state.isNavFixed);
const darkMode = computed(() => store.state.darkMode);
const isAbsolute = computed(() => store.state.isAbsolute);
const showSidenav = computed(() => store.state.showSidenav);
const layout = computed(() => store.state.layout);
const showNavbar = computed(() => store.state.showNavbar);
const showFooter = computed(() => store.state.showFooter);
const showConfig = computed(() => store.state.showConfig);
const hideConfigButton = computed(() => store.state.hideConfigButton);
const toggleConfigurator = () => store.commit("toggleConfigurator");

const navClasses = computed(() => {
  return {
    "position-sticky bg-white left-auto top-2 z-index-sticky":
      isNavFixed.value && !darkMode.value,
    "position-sticky bg-default left-auto top-2 z-index-sticky":
      isNavFixed.value && darkMode.value,
    "position-absolute px-4 mx-0 w-100 z-index-2": isAbsolute.value,
    "px-0 mx-4": !isAbsolute.value,
  };
});
import { Toaster } from 'vue-sonner'
import 'vue-sonner/style.css'
//----- Importing the sseService

import { connectToSSE, addEventListener, closeConnection } from '@/services/sseService';
import { ToastService } from '@/services/toastService'

const message = ref(null);

onMounted( async () => {
  console.log("Connecting to SSE... -> "+process.env.VUE_APP_API_URL+"sse/notifications");
  connectToSSE(process.env.VUE_APP_API_URL+"sse/notifications");

  addEventListener((data) => {
    message.value = data.message;
    //alert(data.message+" "+data.clientId);
    ToastService.success(new Date() + " " + data.message+" "+data.clientId)
  });
  //await loadShops();
});

onUnmounted(() => {
  closeConnection();
});
//----- End of importing the sseService



</script>
<template>
  <Toaster 
    richColors 
    expand 
    closeButton 
    duration="5000" 
    visibleToasts="5"
    closeButtonPosition="top-right"  
    position="bottom-right" />
  <LoadingBar :visible="store.getters.isLoading" />
  <div
    v-show="layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>

  <sidenav v-if="showSidenav" />

  <main id="Id_GoTo_Top"
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
  >
    <!-- nav -->

    <navbar :class="[navClasses]" v-if="showNavbar" />

  <router-view
    :key="$route.meta.forceReload ? $route.fullPath : undefined"
  />

    <app-footer v-show="showFooter" />

    <configurator
      :toggle="toggleConfigurator"
      :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']"
    />
  </main>
</template>
